import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { store } from '@/store';
import VueProgrammaticInvisibleGoogleRecaptcha from 'vue-programmatic-invisible-google-recaptcha';
import userAgent from '@/services/userAgent.service';
import { useRouter } from 'vue-router/composables';
import { useValidator } from '@/core/app.service';
import { useTranslations } from '@/core/translate.mixin';
import RequestMeetingFormService from '@/services/requestmeetingform.service';

import RequestMeetingFormBlockJsonViewModel = Vertica.LouisPoulsen.Application.Content.Blocks.RequestMeetingFormBlockJsonViewModel;
import RequestMeetingFormBlockWebRequest = Vertica.LouisPoulsen.Application.Content.Requests.RequestMeetingFormBlockWebRequest;


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestMeetingForm',
  props: {
    model: null
  },
  setup(__props: any) {

const props = __props as {model: RequestMeetingFormBlockJsonViewModel}


const recaptchaKey = computed<string>(() => store.getters['app/recaptchaKey']);
const componentId = 'requestmeetingFormRecaptcha';
const submittingFormData = ref<boolean>(false);
const _uid = Math.floor(Math.random() * 1000000).toString();
const refs = { [componentId + _uid]: ref(null) };

const formState = ref({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    company: '',
    country: props.model.countries.find(x => x.isDefault),
    profession: undefined,
    comments: '',
    recaptchaToken: '',
    marketingFlagAccepted: false,
    profilingFlagAccepted: false
});

const isPrivateMode = computed<boolean>(() => store.getters['app/isPrivateMode']);
const privacyPolicyUrl = computed<string>(() => store.getters['app/privacyPolicyUrl']);
const { t } = useTranslations();
const privacyPolicyStatementHtml = computed<string>(() => (isPrivateMode.value
    ? t('Shared.Consent.PrivacyPolicyPrefixResidential')
    : t('Shared.Consent.PrivacyPolicyPrefixProfessional'))
    .replace('{0}', privacyPolicyUrl.value));
const newsletterFlagText = computed<string>(() => (isPrivateMode.value ? t('Shared.Consent.MarketingResidential') : t('Shared.Consent.MarketingProfessional')));
const profilingFlagText = computed<string>(() => (isPrivateMode.value ? t('Shared.Consent.ProfilingResidential') : t('Shared.Consent.ProfilingProfessional')));

const runAnimations = ref<boolean>(userAgent.isPrerender);

const $validator = useValidator();

function initAnimations(): void {
    runAnimations.value = true;
}

function setRecaptchaRef(el: any) {
    setTimeout(() => {
        refs[componentId + _uid].value = el;
    }, 100);
}

function enterClicked() {
    validateAndSubmitRequest();
}

function validateAndSubmitRequest() {
    $validator
        .validateAll()
        .then(isValid => {
            if (isValid) {
                const recaptchaComponent = refs[componentId + _uid].value as any;
                    recaptchaComponent.execute();
            } else {
                scrollInvalidElementIntoView();
            }
        })
        .catch(x => console.log('catch error ' + x));
}

const router = useRouter();

function redirectToPage(redirectUrl: string) {
    if (redirectUrl) {
        document.location.href = redirectUrl;
    } else {
        console.error('Error: Confirmation link is missing.');
    }
}

function submitForm(recaptchaToken) {
    submittingFormData.value = true;
    const request: RequestMeetingFormBlockWebRequest = {
        ...formState.value,
        recaptchaToken,
        profession: formState.value.profession.name,
        country: formState.value.country.id
    };
    RequestMeetingFormService.submitForm(request)
        .then((response) => {
            router.replace({ query: {} });
            if (response && response.redirectUrl) {
                redirectToPage(response.redirectUrl);
            } else {
                console.error('Confirmation link is missing.');
            }
        })
        .catch((e) => {
            console.error('submitForm catch', e);
        })
        .finally(() => {
            console.error('submitForm finally');
            submittingFormData.value = false;
        });
}

function scrollInvalidElementIntoView() {
    const firstInvalidElement = document.querySelector('.is-danger');
    if (firstInvalidElement) {
        firstInvalidElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
}


return { __sfc: true,props, recaptchaKey, componentId, submittingFormData, _uid, refs, formState, isPrivateMode, privacyPolicyUrl, t, privacyPolicyStatementHtml, newsletterFlagText, profilingFlagText, runAnimations, $validator, initAnimations, setRecaptchaRef, enterClicked, validateAndSubmitRequest, router, redirectToPage, submitForm, scrollInvalidElementIntoView, VueProgrammaticInvisibleGoogleRecaptcha }
}

})